require('./bootstrap');

document.addEventListener('click', function (event) {
    if (event.target.closest('[data-print-invoice]')) {
        window.print();
    }
});
